import React, { useEffect } from 'react';
import { motion } from 'framer-motion';
import { useNavigate } from 'react-router-dom';

const WelcomeScreen = ({ user, userType }) => {
    const navigate = useNavigate();

    useEffect(() => {
        const timer = setTimeout(() => {
            // Redirect to the appropriate dashboard after the animation
            const destination = userType === 'ngo' ? '/ngo' : '/dashboard';
            navigate(destination, { replace: true });
        }, 4000);

        return () => clearTimeout(timer);
    }, [navigate, userType]);

    const containerVariants = {
        hidden: { opacity: 0 },
        visible: { 
            opacity: 1,
            transition: { duration: 0.5 }
        },
        exit: { 
            opacity: 0,
            transition: { duration: 0.5, delay: 3 }
        }
    };

    const contentVariants = {
        hidden: { opacity: 0, y: 20 },
        visible: { 
            opacity: 1, 
            y: 0,
            transition: { duration: 0.8, delay: 0.3, ease: "easeOut" }
        },
    };

    return (
        <motion.div
            variants={containerVariants}
            initial="hidden"
            animate="visible"
            exit="exit"
            className="fixed inset-0 bg-black flex flex-col items-center justify-center z-50"
        >
            <motion.div 
                variants={contentVariants}
                className="text-center"
            >
                <motion.div
                    className="text-8xl mb-6"
                    animate={{
                        y: [0, -20, 0],
                        rotate: [0, 360]
                    }}
                    transition={{
                        duration: 2,
                        repeat: Infinity,
                        ease: "easeInOut"
                    }}
                >
                    ☺️
                </motion.div>
                <h1 className="text-3xl md:text-4xl font-bold text-white">
                    Welcome, {user?.name || 'Volunteer'}!
                </h1>
                <p className="text-gray-300 text-lg mt-2">Thank you for making a difference.</p>
            </motion.div>
        </motion.div>
    );
};

export default WelcomeScreen;
